<template>
  <header class="o-the-header">
    <MoleculeTheHeaderDataRequire v-if="$store.getters.getIsClientData === false"/>
    <div :class="['o-the-header-navigation', academyDataColor
        ? 'o-the-header-navigation-academycolor'
        : 'o-the-header-navigation-multicolor']">
      <MoleculeTheHeaderLogo :is-loading="isLoading"/>
      <MoleculeTheHeaderNavigation :is-loading="isLoading"/>
      <MoleculeTheHeaderSubMenu/>
    </div>
  </header>
</template>

<script>
export default {
  name: 'OrganismTheHeader',

  components: {
    MoleculeTheHeaderLogo: () => import('@/components/molecules/MoleculeTheHeaderLogo'),
    MoleculeTheHeaderNavigation: () => import('@/components/molecules/MoleculeTheHeaderNavigation'),
    MoleculeTheHeaderSubMenu: () => import('@/components/molecules/MoleculeTheHeaderSubMenu')
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    }
  }
}
</script>
